import { apiClient } from "@/modules/shared/utils/apiClient";

import { ConfirmBookingData } from "../types/ConfirmBookingData";

export const confirmBooking = (data: ConfirmBookingData) =>
  apiClient.post("/coaching-session/book/confirm", data);
